import { startFunnelSession, recordFunnelStep, endFunnelSession, getFunnelSessionState } from "@/utils/behaviorTracker";
import { isValidAicopyModelTier } from "./aicopyModelTier";
import { safeTrack } from "./track";
import { PAGE_KEYS } from "./pageKeys";

function normalizeAicopySymbol(raw) {
  const symbol = String(raw || "")
    .replace(/_/g, "")
    .trim()
    .toUpperCase();
  return symbol || undefined;
}

export function trackAicopyEntryClick({ entry, path = "path_a", pagePath, pageKey = PAGE_KEYS.AICOPY_LIST }) {
  startFunnelSession("aicopy", { path });
  recordFunnelStep(1);
  return safeTrack("aicopy_entry_click", {
    page: pagePath || "",
    properties: { entry, page_key: pageKey, path },
  });
}

export function trackAicopySignalClick({ symbol, modelId, pagePath, pageKey = PAGE_KEYS.AICOPY_SIGNAL }) {
  const normalizedSymbol = normalizeAicopySymbol(symbol);
  if (!normalizedSymbol) return null;
  startFunnelSession("aicopy", { path: "path_b" });
  recordFunnelStep(1);
  return safeTrack("aicopy_signal_click", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      path: "path_b",
      symbol: normalizedSymbol,
      model_id: String(modelId || ""),
    },
  });
}

export function trackAicopyPageView({ path = "path_a", pagePath, pageKey = PAGE_KEYS.AICOPY_LIST }) {
  recordFunnelStep(2, { path });
  return safeTrack("aicopy_page_view", {
    page: pagePath || "",
    properties: { page_key: pageKey, path },
  });
}

export function trackAicopySignalPageView({ symbol, modelId, pagePath, pageKey = PAGE_KEYS.AICOPY_SIGNAL }) {
  const normalizedSymbol = normalizeAicopySymbol(symbol);
  if (!normalizedSymbol) return null;
  recordFunnelStep(2, { path: "path_b" });
  return safeTrack("aicopy_signal_page_view", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      path: "path_b",
      symbol: normalizedSymbol,
      model_id: String(modelId || ""),
    },
  });
}

export function trackAicopyModelSelect({ path, modelId, modelTier, pagePath, pageKey = PAGE_KEYS.AICOPY_LIST }) {
  if (!modelTier || !isValidAicopyModelTier(modelTier)) return null;
  recordFunnelStep(3, { path });
  return safeTrack("aicopy_model_select", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      path,
      model_id: String(modelId || ""),
      model_tier: String(modelTier).trim().toUpperCase().replace(/[\s-]+/g, "_"),
    },
  });
}

export function trackAicopyAmountConfirm({ path, amount, currency, pagePath, pageKey = PAGE_KEYS.AICOPY_LIST }) {
  recordFunnelStep(4, { path });
  return safeTrack("aicopy_amount_confirm", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      path,
      amount: String(amount),
      currency: String(currency || "").toUpperCase(),
    },
  });
}

export function trackAicopyFail({ path, errorCode, lastStep, pagePath, pageKey = PAGE_KEYS.AICOPY_LIST }) {
  return safeTrack("aicopy_fail", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      path,
      error_code: String(errorCode || "UNKNOWN"),
      last_step: Number(lastStep || 1),
    },
  });
}

export function trackAicopyAbandon({ path, lastStep, pagePath, pageKey = PAGE_KEYS.AICOPY_LIST }) {
  const state = getFunnelSessionState();
  safeTrack("aicopy_abandon", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      path: path || state?.path || "path_a",
      last_step: Number(lastStep != null ? lastStep : state?.lastStep || 1),
    },
  });
  endFunnelSession();
}
